export default async function getJWTs(nonce, ajaxURL, vehiclesData) {
    let vehiclesJSON = {};
    
    Object.keys(vehiclesData).forEach((key) => {
        vehiclesJSON[key] = JSON.stringify(vehiclesData[key]);
    });

    const data = new FormData();
    data.append('action', 'jwt_tokens_generation_request');
    data.append('_wpnonce', nonce);
    data.append('vehicles_data', JSON.stringify(vehiclesJSON));

    const request = await window.fetch(ajaxURL, {
        method: 'POST',
        body: data
    })
    .then((response) => response.json())
    .then((result) => result.data)
    .catch((err) => console.warn('Impossible de récupérer les tokens JWT', err));

    return request;
}